import MenuLink from "./MenuLink";

export type { MenuLinkProps, MenuItemProps } from "./MenuLink.d";

export default MenuLink;
